import { Badge, Box, SvgIcon, Tooltip } from '@mui/material';
import CheckIcon from 'assets/icons/check.svg';
import InviteIcon from 'assets/icons/invite.svg';
import StarIcon from 'assets/icons/star.svg';
import { any, bool, func, node, oneOf } from 'prop-types';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';

const badgeSx = {
  backgroundColor: 'transparent',
  display: 'inherit',
};

const iconPendingSx = {
  color: 'secondary.main',
  fontSize: 16,
};

const iconAdminSx = theme => ({
  borderRadius: '50%',
  backgroundColor: theme.palette.admin,
  color: theme.palette.white,
  fontSize: 16,
  padding: '3px',
});

const iconActiveSx = theme => ({
  borderRadius: '50%',
  backgroundColor: theme.palette.ok,
  color: theme.palette.white,
  fontSize: 16,
  padding: '3px',
});

const iconSxByStatus = {
  pending: iconPendingSx,
  admin: iconAdminSx,
  active: iconActiveSx,
};

const icons = {
  active: CheckIcon,
  admin: StarIcon,
  pending: InviteIcon,
};

const BadgeIcon = ({ status }) => {
  const IconComponent = icons[status];
  if (!IconComponent) {
    return null;
  }
  return (
    <SvgIcon sx={iconSxByStatus[status]}>
      <IconComponent />
    </SvgIcon>
  );
};

BadgeIcon.propTypes = {
  status: oneOf(['pending', 'active', 'admin']).isRequired,
};

const AvatarBadge = ({
  children,
  enable,
  className = null,
  status = 'active',
  onClick = () => {},
}) =>
  enable ? (
    <Tooltip className={className} placement="top" title={I18n.t(`AvatarBadge.${status}`)}>
      <Badge
        onClick={onClick}
        badgeContent={<BadgeIcon status={status} />}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        overlap="circular"
        color="primary"
        slotProps={{ badge: { sx: badgeSx } }}
      >
        {children}
      </Badge>
    </Tooltip>
  ) : (
    <Box className={className}>{children}</Box>
  );

AvatarBadge.propTypes = {
  onClick: func,
  children: node.isRequired,
  enable: bool.isRequired,
  className: any,
  status: oneOf(['pending', 'active', 'admin']),
};

export default memo(AvatarBadge);
